<div class="content-list-grid">
  @for (item of items | async; track item; let i = $index) {
    <a
      class="grid-item"
      [href]="item.link"
      target="_parent"
      [attr.aria-label]="item.title"
      >
      <div class="img" [ngStyle]="getImgStyle(item.imageUrl, i)">
        <!-- Uncomment this for a funky word pattern thing I made to fill the empty space on items with no image -->
        <!-- <div
        *ngIf="!(item.imageUrl && item.imageUrl.length > 0)"
        class="word-pattern"
        >
        <span *ngFor="let x of [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]">{{
          item.description && item.description.length > 0
          ? item.description
          : item.title
        }} </span>
      </div> -->
    </div>
    <div class="text">
      <span class="type">
        {{ !!item.display_type && item.display_type.length>0 ? item.display_type : item.type }}
      </span>
      <span class="title" [ngClass]="{ 'small-text': item.title.length > 64 }">
        {{ item.title }}
      </span>
    </div>
  </a>
}
</div>
